module.exports = __webpack_public_path__ + "img/rate4.086e4800.png";